export default __webpack_public_path__ + "static/media/contact.5fbb6036.svg";